export const WAIT_AUTHORIZATION_KEY = '0' // 待授权
export const WAIT_CONFIRM_KEY = '1' // 待审核
export const CONFIRMED_KEY = '2' // 合作中
export const REFUSE_KEY = '3' // 拒绝合作
export const CANCELLED_KEY = '4' // 终止合作

export const MAP = {
    [WAIT_AUTHORIZATION_KEY]: '待授权',
    [WAIT_CONFIRM_KEY]: '待审核',
    [CONFIRMED_KEY]: '合作中',
    [REFUSE_KEY]: '已拒绝',
    [CANCELLED_KEY]: '已终止'
}

export const LIST = [WAIT_CONFIRM_KEY, WAIT_AUTHORIZATION_KEY, CONFIRMED_KEY, REFUSE_KEY, CANCELLED_KEY].map(v => ({
    value: v,
    label: MAP[v]
}))

export const DIS_FUNDS_PAGE_LIST = [
    CONFIRMED_KEY,
    WAIT_AUTHORIZATION_KEY,
    WAIT_CONFIRM_KEY,
    REFUSE_KEY,
    CANCELLED_KEY
].map(v => ({
    value: v,
    label: MAP[v]
}))

export const transToLabel = key => MAP[key]

export const NO_WAIT_CONFIRM_LIST = [CONFIRMED_KEY, WAIT_AUTHORIZATION_KEY, REFUSE_KEY, CANCELLED_KEY].map(v => ({
    value: v,
    label: MAP[v]
}))

// lastCancelOriginator-终止方 SUPPLIER-供应商 CHANNEL-渠道商  （在我的供应商中，CHANNEL-代表主动终止   SUPPLIER-被动终止）
export const LAST_CANCEL_ORIGINATOR_CHANNEL = 'CHANNEL'
export const LAST_CANCEL_ORIGINATOR_SUPPLIER = 'SUPPLIER'
export const LAST_CANCEL_COOP_TYPE_MAP = {
    [LAST_CANCEL_ORIGINATOR_SUPPLIER]: '被动终止',
    [LAST_CANCEL_ORIGINATOR_CHANNEL]: '主动终止'
}
export const LAST_CANCEL_TYPE_OPTIONS = [
    {
        label: '全部',
        value: 'ALL'
    },
    {
        label: LAST_CANCEL_COOP_TYPE_MAP[LAST_CANCEL_ORIGINATOR_CHANNEL],
        value: LAST_CANCEL_ORIGINATOR_CHANNEL
    },
    {
        label: LAST_CANCEL_COOP_TYPE_MAP[LAST_CANCEL_ORIGINATOR_SUPPLIER],
        value: LAST_CANCEL_ORIGINATOR_SUPPLIER
    }
]
